import { React, useState } from 'react'
import styled from 'styled-components'
import diamond from '../../assets/diamond.png'
import UserImpact from './UserImpact'
import StyledButtonGoBack from '../shared/GoBackButton'
import { useNavigate } from 'react-router-dom' // Importer useNavigate
import ReportUser from './ReportUser'
import colors from '../../styles/colors'

const StyledProfileShort = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 300px;
    height: 100vh;
    padding: 50px 10px;
    box-shadow: 0 -20px 50px grey;
`

const StyledUserPicture = styled.div`
    display: flex;
    position: relative;
    height: 150px;
    border-radius: 100px;
    margin: 20px 0 0 0;
`
const StyledUserPictureImg = styled.img`
    position: absolute;
    top: 0;
    right: -75px;
    border-radius: 100px;
    height: 150px;
    width: 150px;
    object-fit: cover;
    box-shadow: 0 0 50px grey;
    &:hover {
        cursor: pointer;
        filter: brightness(0.9);
    }
`
const StyledUserPicturePremium = styled.img`
    position: absolute;
    top: 5px;
    right: -80px;
    width: 40px;
    object-fit: cover;
    aspect-ratio: 1/1;
    background-color: white;
    border-radius: 50px;
    padding: 8px;
    box-shadow: 0 0 15px grey;
`
const StyledPseudo = styled.div`
    color: ${colors.forth};
    font-weight: bold;
    margin: 20px;
`
const StyledReportButton = styled.div`
    display: flex;
    padding: 10px 20px;
    margin: 40px;
    border-radius: 15px;
    align-items: center;
    background-color: #7f0e0e;
    color: white;
    font-size: 80%;
    &:hover {
        cursor: pointer;
        filter: brightness(0.8);
        text-decoration: underline;
    }
`

function ProfileShort({ userInfo, sellerInfo }) {
    const navigate = useNavigate() // Initialiser le hook useNavigate
    const [isReportVisible, setIsReportVisible] = useState(false)

    return (
        <StyledProfileShort>
            {/* <StyledButtonGoBack /> */}
            <StyledUserPicture>
                <StyledUserPictureImg
                    src={sellerInfo.pictureUrl}
                    alt="User"
                    onClick={() => navigate(`/PublicProfile/${sellerInfo._id}`)}
                />
                {sellerInfo.premium && (
                    <StyledUserPicturePremium src={diamond} alt="premium" />
                )}
            </StyledUserPicture>
            <StyledPseudo>{sellerInfo.pseudo}</StyledPseudo>
            <UserImpact userInfo={sellerInfo} width="160px" />
            {userInfo && userInfo._id !== sellerInfo._id && (
                <StyledReportButton onClick={() => setIsReportVisible(true)}>
                    Signaler
                </StyledReportButton>
            )}
            {isReportVisible && (
                <ReportUser
                    setIsReportVisible={setIsReportVisible}
                    reportedUserId={sellerInfo._id}
                    onClick={() => setIsReportVisible(true)}
                />
            )}
        </StyledProfileShort>
    )
}

export default ProfileShort
